import React from 'react';
import { Badge, Col, Nav, Navbar, NavDropdown, Row } from 'react-bootstrap';
import logo from '../../../images/blue_logo.svg';
import Button from '../../components/Button';
import CustomNavDropdown from '../../components/Nav/NavDropdown';
import NavLink from '../../components/Nav/NavLink';

const Navbars = () => (
  <Row className="styles-section" id="navbars">
    <Col xs={12}>
      <h3>Navbars</h3>
    </Col>
    <Col xs={12} sm={6}>
      <Navbar collapseOnSelect bg="light" expand="xs">
        <Navbar.Brand >
          <img className="header-logo" src={logo} />
        </Navbar.Brand>

        <Nav className="nav-no-collapsible">
          <Nav.Link className="p-0">
            <Button variant="tertiary">
              <i className="fal fa-home"></i>
              <Badge variant="dark" >3</Badge>
            </Button>
          </Nav.Link>
          <Nav.Link>
            <i className="fal fa-user"></i>
          </Nav.Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
        </Nav>

        <Navbar.Collapse className="preview" id="basic-navbar-nav">
          <Nav>
            <Nav.Link href="#home">
              <Button variant="tertiary">
                Home
                <span>
                  <Badge variant="dark">3</Badge>
                  <i className="fal fa-arrow-right" />
                </span>
              </Button>
            </Nav.Link>
            <Nav.Link href="#link">
              <Button variant="tertiary">
                Analytics
                <span>
                  <i className="fal fa-arrow-right" />
                </span>
              </Button>
            </Nav.Link>

            <CustomNavDropdown className="preview" title="Dropdown" id="basic-dropdown">
              <NavDropdown.Item href="#action/3.1">Home</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <CustomNavDropdown className="preview" title="Inner dropdown" id="inner-dropdown">
                <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
              </CustomNavDropdown>
            </CustomNavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </Col>
    <Col xs={12} sm={6}>
    </Col>

    <Col xs={12} sm={8}>
      <Nav
        className="navbar-secondary"
        bg="light"
        variant="tabs"
        defaultActiveKey="/"
        style={{
          position: 'relative'
        }}>
        <Nav.Link eventKey="/">General</Nav.Link>
        <Nav.Link eventKey="/brief">Brief</Nav.Link>
        <Nav.Link eventKey="/mood">Mood board</Nav.Link>
        <Nav.Link eventKey="/questions">Questions</Nav.Link>
        <Nav.Link eventKey="/brand">Brand</Nav.Link>

      </Nav>

    </Col >
    <Col xs={12} sm={4}>
    </Col>

    <Col xs={12}>
      <Navbar collapseOnSelect bg="light" expand="sm">
        <Navbar.Brand >
          <img className="header-logo" src={logo} />
        </Navbar.Brand>

        <Nav className="nav-no-collapsible">
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
        </Nav>

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav>
            <NavLink href="#home" text="Home" />
            <NavLink href="#link" text="Link" />
            <CustomNavDropdown title="Dropdown" id="basic-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
            </CustomNavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </Col>


  </Row >
);

export default Navbars;